import { FILTERS } from '../constants';

export const generateTableKey = (header_title, row_id) => {
  const rand_str = Math.random().toString(36);
  return header_title ? `${header_title}_${row_id}` : `${rand_str}_${row_id}`;
}

export const addFilterIfPresent = (filter, dropdownOptions) => {
  let filterString = ''

  if (filter) {
    let filterPair = {};
    filterPair = FILTERS[filter];
    if (filterPair === undefined) {
      return false;
    }
    const filterKey = filterPair.key;
    const filterValue = filterPair.value;
    if (filterKey.search('dropdown_option_id') !== -1) {
      const value = dropdownOptions.filter((o) => o.code_key === filterValue)[0];
      if (filterKey && filterValue && value) {
        filterString = `?filters={"or":[{"column":"${filterKey}","value":"${value.id}","operator":"="}]}`;
      }
    } else {
      filterString = `?filters={"custom":"${filterKey}"}`;
    }
  }
  return filterString;
}

export const flattenArrayAndStringify = (array) => {
  if (Array.isArray(array)) {
    let stringArray = array.map((item) => {
      return JSON.stringify(item)
    })
    return stringArray.join(',')
  } else {
    return JSON.stringify(array)
  }
}

export const concatFiltersOnUrl = (url, secondFilterArray, thirdFilterArray = [], fourthFilterArray) => {
  // TODO: We are doing this so that users can see approved and declined.
  // we will fix the advanced search later, but for now, this will allow them to see the other values if they want to.
  let moduleKey = url.split('?')[0];
  if (moduleKey == "manager_approval" && thirdFilterArray && thirdFilterArray.length > 0) {
    url = 'manager_approval'
  }

  // url may look like  payment?filters={"or":[{"column":"payment_status_dropdown_option_id","value":"1125","operator":"="}]}
  // OR url may look like payment?filters={"and":[{"or":[{"column":"lead_status_dropdown_option_id","value":"1100","operator":"="}]},{"or":[{"column":"lead_approval_status_dropdown_option_id","value":536,"operator":"="}]}]}
  // secondFilterArray looks like [{"column":"payment_status_dropdown_option_id","value":"1125","operator":"="}]
  if (thirdFilterArray.length > 0 && secondFilterArray != null) {
    if (fourthFilterArray) {
      url += `?filters={"and":[{"or":${JSON.stringify(secondFilterArray)}},${flattenArrayAndStringify(thirdFilterArray)},${flattenArrayAndStringify(fourthFilterArray)}]}`
    } else {
      url += `?filters={ "and":[{ "or":${JSON.stringify(secondFilterArray)}},${flattenArrayAndStringify(thirdFilterArray)}]}`;
    }
  } else if (thirdFilterArray.length > 0 && secondFilterArray == null && url.search('filters') === -1) {
    if (fourthFilterArray) {
      url += `?filters={"and": [${flattenArrayAndStringify(thirdFilterArray)},${flattenArrayAndStringify(fourthFilterArray)}]}`;
    } else {
    url += `?filters={"and":${JSON.stringify(thirdFilterArray)}}`;
    }
  } else if (url.search('filters') !== -1) {
    const baseUrl = url.split('?')[0];
    const urlFilters = url.split('filters=')[1];
    let firstFilterArray = JSON.parse(urlFilters);
    let andArray = [];

    const determineArrayPush = (array) => {
      if (array?.or || array?.and || !Array.isArray(array)) {
        return [array]
      } else if (Array.isArray(array)) {
        return [{ or: array }]
      } else {
        return [{ or: [array] }]
      }
    }
    let firstArrayCopy = firstFilterArray ? determineArrayPush(firstFilterArray) : null
    let secondArrayCopy = secondFilterArray ? determineArrayPush(secondFilterArray) : null
    let thirdArrayCopy = thirdFilterArray ? determineArrayPush(thirdFilterArray) : null
    let fourthArrayCopy = fourthFilterArray ? determineArrayPush(fourthFilterArray) : null

    andArray = andArray.concat([
      ...firstArrayCopy || [],
      ...secondArrayCopy || [],
      ...thirdArrayCopy || [],
      ...fourthArrayCopy || []
    ])

    const andObj = { and: andArray };
    url = `${baseUrl}?filters=${JSON.stringify(andObj)}`;
  } else if (fourthFilterArray) {
      url += `?filters={"and": [{"or":${JSON.stringify(Array.isArray(secondFilterArray) ? secondFilterArray : [secondFilterArray])}}, ${flattenArrayAndStringify(fourthFilterArray)}]}`;
    } else {
      url += `?filters={"or":${JSON.stringify(Array.isArray(secondFilterArray) ? secondFilterArray : [secondFilterArray])}}`;
    }

  return url;
}

export const concatSortOnUrl = (url, sort) => {
  // url may look like  payment?filters={"or":[{"column":"payment_status_dropdown_option_id","value":"1125","operator":"="}]}&sort=payment_date,-created_at
  // OR url may look like  only `payment` (no filters nor sort) or just filters or just sort
  if (sort === undefined || sort === null || sort === '') {
    return url;
  }

  if (url.search('filters') === -1 && url.search('sort') === -1) {
    url += `?sort=${sort}`;
  } else if (url.search('filters') !== -1 && url.search('sort') === -1) { // url has filters but no sort
    url += `&sort=${sort}`;
  } else if (url.search('filters') === -1 && url.search('sort') !== -1) { // url has sort but no filters
    const urlParts = url.split('sort=');
    url = `${urlParts[0]}sort=${sort},${urlParts[1]}`;
  } else if (url.search('filters') !== -1 && url.search('sort') !== -1) { // url has both filters and sort
    let urlQueryString = url.split('?')[0];
    const urlQueryStringParts = urlQueryString[1].split('&');
    if (urlQueryStringParts[1].search('sort') !== -1) {
      url = `${url},${sort}`;
    } else {
      urlQueryStringParts[0] += `,${sort}`;
      url = `${urlQueryStringParts[0]}&${urlQueryStringParts[1]}`;
    }
  }
  return url;
}
